import { FETCH_BUSINESS_LIST_SUCCESS, FETCH_CARRIER_LIST_SUCCESS, FETCH_MARKETPLACE_LIST_SUCCESS, FETCH_PRODUCT_TYPE_LIST_SUCCESS, FETCH_USER_ONBOARDING_FAILED, FETCH_USER_ONBOARDING_PENDING, FETCH_USER_ONBOARDING_SUCCESS } from "../types";

const initialState = {
    accountDetails: {},
    accountDetailsStatus: '',
    additionalDetails: {},
    businessList: [],
    productTypeList: [],
    marketplaceList: [],
    carrierList: [],
};
const UsersOnboardingReducer = (state = initialState, action = '') => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_USER_ONBOARDING_PENDING:
            return {
                ...state,
                accountDetails: {},
                accountDetailsStatus: 'pending'
            };
        case FETCH_USER_ONBOARDING_SUCCESS:
            return {
                ...state,
                accountDetails: payload,
                accountDetailsStatus: 'success'
            };
        case FETCH_USER_ONBOARDING_FAILED:
            return {
                ...state,
                accountDetails: {},
                accountDetailsStatus: 'failed'
            };
        case FETCH_BUSINESS_LIST_SUCCESS:
            return {
                ...state,
                businessList: payload,
            };
        case FETCH_PRODUCT_TYPE_LIST_SUCCESS:
            return {
                ...state,
                productTypeList: payload,
            };
        case FETCH_MARKETPLACE_LIST_SUCCESS:
            return {
                ...state,
                marketplaceList: payload,
            };
        case FETCH_CARRIER_LIST_SUCCESS:
            return {
                ...state,
                carrierList: payload,
            };
        default:
            return state;
    }
}
export default UsersOnboardingReducer;

